const apiHost = "https://flask-api-aomh7gr2xq-ue.a.run.app";
// const apiHost = "http://127.0.0.1:8080"; //this is local api
export { apiHost as default };
